import * as yup from "yup";

import { CantidadSchema } from "./CantidadSchema";
import { CASRegex } from "../utils/regex";

export const SustanciaQuimicaSchema = yup.object().shape({
  orden: yup
    .number()
    .min(0, "errors.cantidad.magnitud.min")
    .required("errors.sustanciaQuimica.nombreComercial.required")
    .default(0),
  nombreComercial: yup
    .string()
    .uppercase()
    .max(100, "errors.sustanciaQuimica.nombreComercial.max")
    .required("errors.sustanciaQuimica.nombreComercial.required")
    .default(""),
  nombreQuimico: yup
    .string()
    .uppercase()
    .max(100, "errors.sustanciaQuimica.nombreQuimico.max")
    .required("errors.sustanciaQuimica.nombreQuimico.required")
    .default(""),
  CAS: yup
    .string()
    .nullable()
    .transform((value) => (value === "" ? null : value))
    .test(
      "cas.required",
      "errors.sustanciaQuimica.CAS.required",
      (value) => value != null && value !== "",
    )
    .test(
      "cas.format",
      "errors.sustanciaQuimica.CAS.regex",
      (value) => !value || CASRegex.test(value),
    )
    .max(20, "errors.sustanciaQuimica.CAS.max")
    .default(null),
  operacionesUnitarias: yup
    .array()
    .min(1, "errors.sustanciaQuimica.operacionesUnitarias.min")
    .required("errors.sustanciaQuimica.operacionesUnitarias.required")
    .default([]),
  cantidad: CantidadSchema.required("errors.sutanciaQuimica.cantidad.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: undefined }),
});
